// THIS FILE WAS GENERATED AND SHOULD NOT BE MODIFIED!
import React from 'react';
import { Row, Col, Nav } from 'seduo-ui';
import NavLink from '../UI/NavLink';
class Components extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            navItems: [
                {
                    name: 'Additional Menu',
                    to: 'components/additional-menu/',
                },
                {
                    name: 'Alerts',
                    to: 'components/alerts/',
                },
                {
                    name: 'Badge',
                    to: 'components/badge/',
                },
                {
                    name: 'Banner',
                    to: 'components/banner/',
                },
                {
                    name: 'Blog Thumb',
                    to: 'components/blog-thumb/',
                },
                {
                    name: 'Breadcrumbs',
                    to: 'components/breadcrumbs/',
                },
                {
                    name: 'Buttons',
                    to: 'components/buttons/',
                },
                {
                    name: 'Card',
                    to: 'components/card/',
                },
                {
                    name: 'Carousel',
                    to: 'components/carousel/',
                },
                {
                    name: 'Category List',
                    to: 'components/category-list/',
                },
                {
                    name: 'Checkable Box',
                    to: 'components/checkable-box/',
                },
                {
                    name: 'Checkbox List',
                    to: 'components/checkbox-list/',
                },
                {
                    name: 'Chip',
                    to: 'components/chip/',
                },
                {
                    name: 'Content',
                    to: 'components/content/',
                },
                {
                    name: 'Course Image',
                    to: 'components/course-image/',
                },
                {
                    name: 'Cover',
                    to: 'components/cover/',
                },
                {
                    name: 'Dropdowns',
                    to: 'components/dropdowns/',
                },
                {
                    name: 'Fade',
                    to: 'components/fade/',
                },
                {
                    name: 'Form',
                    to: 'components/form/',
                },
                {
                    name: 'Highlight',
                    to: 'components/highlight/',
                },
                {
                    name: 'Image Badge',
                    to: 'components/image-badge/',
                },
                {
                    name: 'Image',
                    to: 'components/image/',
                },
                {
                    name: 'Layout',
                    to: 'components/layout/',
                },
                {
                    name: 'Link Button',
                    to: 'components/link-button/',
                },
                {
                    name: 'Modals',
                    to: 'components/modals/',
                },
                {
                    name: 'Pills Menu',
                    to: 'components/pills-menu/',
                },
                {
                    name: 'Progress',
                    to: 'components/progress/',
                },
                {
                    name: 'Ratings',
                    to: 'components/ratings/',
                },
                {
                    name: 'Search',
                    to: 'components/search/',
                },
                {
                    name: 'Separator',
                    to: 'components/separator/',
                },
                {
                    name: 'Skeleton',
                    to: 'components/skeleton/',
                },
                {
                    name: 'Slider',
                    to: 'components/slider/',
                },
                {
                    name: 'Spinner',
                    to: 'components/spinner/',
                },
                {
                    name: 'Sticky Bar',
                    to: 'components/sticky-bar/',
                },
                {
                    name: 'Tabs',
                    to: 'components/tabs/',
                },
                {
                    name: 'Testimonial',
                    to: 'components/testimonial/',
                },
                {
                    name: 'Tile',
                    to: 'components/tile/',
                },
            ],
        };
    }
    render() {
        return (<Row>
                <Col md={{ size: 3, order: 2 }}>
                    <div className="docs-sidebar mb-3">
                        <h5>Components</h5>
                        <Nav className="flex-column">
                            {this.state.navItems.map((item, i) => (<NavLink key={i} {...item}/>))}
                        </Nav>
                    </div>
                </Col>
                <Col md={{ size: 9, order: 1 }}>{this.props.children}</Col>
            </Row>);
    }
}
export default Components;
